import { LloFunnelReportItem } from "../../../../api";
import type { FilterFieldKey, LloFunnelFiltersState } from "./types";
import { EMPTY_FILTERS } from "./types";

const FUNNEL_SEPARATOR = " — ";

export function parseFunnel(funnel?: string | null): { category: string; stage: string | null } {
  const value = (funnel ?? "").trim();
  if (!value) return { category: "—", stage: null };

  const sepIndex = value.indexOf(FUNNEL_SEPARATOR);
  if (sepIndex === -1) {
    return { category: value, stage: null };
  }

  return {
    category: value.slice(0, sepIndex).trim() || "—",
    stage: value.slice(sepIndex + FUNNEL_SEPARATOR.length).trim() || null,
  };
}

export function uniqueFilterOptions(
  rows: LloFunnelReportItem[],
  field: FilterFieldKey
): string[] {
  if (field === "overdue" || field === "negotiation" || field === "funnel") {
    return [];
  }

  const values = new Set<string>();
  rows.forEach((row) => {
    const value = String(row[field as keyof LloFunnelReportItem] ?? "").trim();
    if (value) values.add(value);
  });
  return [...values].sort((a, b) => a.localeCompare(b));
}

export function mergeUniqueOptions(...lists: Array<string[] | undefined>): string[] {
  const values = new Set<string>();
  lists.forEach((list) => {
    list?.forEach((value) => {
      const trimmed = value.trim();
      if (trimmed) values.add(trimmed);
    });
  });
  return [...values].sort((a, b) => a.localeCompare(b));
}

export function countActiveFilters(filters: LloFunnelFiltersState): number {
  let count = 0;
  (Object.keys(filters) as (keyof LloFunnelFiltersState)[]).forEach((key) => {
    const value = filters[key];
    if (
      key === "dueDateFrom" ||
      key === "dueDateTo" ||
      key === "lloExpirationFrom" ||
      key === "lloExpirationTo"
    ) {
      if (value != null) count += 1;
      return;
    }
    if (typeof value === "string" && value.trim()) count += 1;
  });
  return count;
}

export function hasActiveFilters(filters: LloFunnelFiltersState): boolean {
  return countActiveFilters(filters) > 0;
}

export function clearFilterField(
  filters: LloFunnelFiltersState,
  key: keyof LloFunnelFiltersState
): LloFunnelFiltersState {
  if (
    key === "dueDateFrom" ||
    key === "dueDateTo" ||
    key === "lloExpirationFrom" ||
    key === "lloExpirationTo"
  ) {
    return { ...filters, [key]: null };
  }
  return { ...filters, [key]: "" };
}

export function resetFilters(): LloFunnelFiltersState {
  return { ...EMPTY_FILTERS };
}
